import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({})).set('Search', new Immutable.List([])).set('SearchEval', new Immutable.List([]))

/* Types */

export const ACTION_NEW_DEC_OR_INC_DONATION = 'ACTION_NEW_DEC_OR_INC_DONATION'

export const ACTION_GET_DEC_OR_INC_DONATION = 'ACTION_GET_DEC_OR_INC_DONATION'

export const ACTION_SEARCH_DEC_OR_INC_DONATION = 'ACTION_SEARCH_DEC_OR_INC_DONATION'

export const ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION = 'ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION'

export const ACTION_UPDATE_DEC_OR_INC_DONATION = 'ACTION_UPDATE_DEC_OR_INC_DONATION'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_NEW_DEC_OR_INC_DONATION:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_GET_DEC_OR_INC_DONATION:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_DEC_OR_INC_DONATION:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION:
			return state.set('SearchEval', new Immutable.List(action.Obj))
		case ACTION_UPDATE_DEC_OR_INC_DONATION:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const newDecOrIncDonationAssigned = (form) => {

	let temp = {
		configuracionId: !form.configuracionId ? 0 : form.configuracionId,
		descripcion: form.descripcion,
		deleted: form.state === 1 ? false : true,
		limiteExcepcion: form.limite || false,
		monto: form.monto ? parseInt(form.monto) : 0,
		usuario: sessionStorage.uid,

		evaluacionesRango: form.formWithVariableSelected,
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: !form.configuracionId ? 'api/newDecOrIncDonationAssigned' : 'api/updateDecOrIncDonationAssigned',
			method: "POST",
			data: temp,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_NEW_DEC_OR_INC_DONATION, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getDecOrIncDonationAssigned = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getDecOrIncDonationAssigned',
			method: "POST",
			data: {id},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			let data = response.data.configuracionFuncion
			let evaluacionesRango = response.data.evaluacionesRango

			let temp = {
				uniqueId: Utils.getUUID(),
				configuracionId: data.configuracionFuncionPK.configuracionId,
				descripcion: data.descripcion,
				state: !data.deleted ? 1 : 2,
				limite: data.limiteExcepcion,
				monto: data.monto || '',

				evaluacionesRangoUpdate: evaluacionesRango
			}

			dispatch({ type: ACTION_GET_DEC_OR_INC_DONATION, Obj: temp })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchDecOrIncDonationAssigned = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchDecOrIncDonationAssigned' : 'api/searchParamDecOrIncDonationAssigned',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			let data = response.data.map((d) => {
				return {
					...d,
					id: d.configuracionFuncionPK.configuracionId
				}
			})

			data.uniqueId = Utils.getUUID()

			dispatch({ type: ACTION_SEARCH_DEC_OR_INC_DONATION, Obj: data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchEvaluacionVarDecOrIncDonationAssigned = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/searchEvaluacionVarDecOrIncDonationAssigned',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			dispatch({ type: ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION, Obj: response.data })
			return response.data;
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/Functions/DecOrIncDonationAssigned/index.js